export { default } from "./Typography"
